<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <f7-block>
    <p>Muestra una lista vacía con título, subtítulo e icono</p>
    <ol>
      <li>Si no se especifica icono, será uno por defecto</li>
      <li>Lanza un evento "click-icon" al hacer click en el icono</li>
    </ol>
    <UCEmptyList
      title="Sin documento seleccionado"
      subtitle="Pulse el botón para añadir un nuevo documento"
      icon="./static/icons/ic_qr.svg"
    />
  </f7-block>
</template>

<script>
import UCEmptyList from '@/components/common/UCEmptyList.vue';

export default {
  name: 'TestUCEmptyList',
  components: {
    UCEmptyList,
  },
};
</script>
